import catalogJson from '../../content/lessons/catalog.json';
import { LessonDoc, LessonMeta } from './types';

// The JSON's inferred type widens the unions (species, type) to string, so the
// cast is unavoidable. src/content/lessons/catalog.test.ts is what actually
// guarantees those fields hold only the expected values.
const catalog = catalogJson as unknown as LessonMeta[];
const bySlug = new Map(catalog.map((lesson) => [lesson.slug, lesson]));

export function listLessons(): LessonMeta[] {
  return catalog;
}

// Content ships in the bundle, so a miss is a bad slug (deep link, stale Zendesk
// macro) rather than a network failure — callers get null and render a not-found.
export function loadLesson(slug: string): LessonDoc | null {
  const meta = bySlug.get(slug);
  if (!meta) return null;
  try {
    // eslint-disable-next-line global-require, import/no-dynamic-require
    const doc = require(`../../content/lessons/blocks/${slug}.json`);
    return { ...meta, chapters: doc.chapters || [], blocks: doc.blocks || [] };
  } catch (err) {
    return null;
  }
}
